import {
  BookingWrapperSingle,
  BookingWrapperGroup,
  BookingImgSingle,
  BookingImgGroup,
  BookingLabelWrapper,
  BookingTypeLabel
} from './booking-list-styles'
import SingleBookingLabel from './assets/single-booking-label.svg'
import GroupBookingLabel from './assets/group-booking-label.svg'

export const BookingListLabel = () => {
  return (
    <>
      <BookingLabelWrapper>
        <BookingWrapperSingle>
          <BookingImgSingle src={SingleBookingLabel} />
          <BookingTypeLabel>Single booking</BookingTypeLabel>
        </BookingWrapperSingle>
        <BookingWrapperGroup>
          <BookingImgGroup src={GroupBookingLabel} />
          <BookingTypeLabel>Group booking</BookingTypeLabel>
        </BookingWrapperGroup>
      </BookingLabelWrapper>
    </>
  )
}
